import { useQuery } from '@tanstack/react-query';
import { GlobalReactQueryOptions } from '../../../../config';
import { fetchFinancialYears } from './apiFetchFinancialYears';

const FINANCIAL_YEARS_QUERY = 'financialYears';

export const useGetFinancialYears = () => {
    return useQuery([FINANCIAL_YEARS_QUERY], fetchFinancialYears, { ...GlobalReactQueryOptions });
};
